import { css } from "styled-components";
import media from "../../assets/css/media";

export const padding_mobile_css = css`
	@media( max-width: ${media.desktop} ) {
		padding: 0 10px;
	}

`;
